<template>
  <div>
    <Form :label-width="120" label-position="left">
      <Row :gutter="30">
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Meeting_Subjects')"
            ><!-- 会议名称 -->
            <Input v-model="searchItem.meetingName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Meeting_Date')"
            ><!-- 会议时间 -->
            <DatePicker
              type="date"
              v-model="searchItem.meetingDate"
              style="width: 100%"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('PB_Meeting_Owner')"
            ><!-- 会议管理员 -->
            <Input v-model="searchItem.hostId" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Meeting_Type')"
            ><!-- 会议类型 -->
            <Select v-model="searchItem.meetingType" clearable>
              <Option
                v-for="item in meetingTypeList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Appraisee')"
            ><!-- 被评估人员 -->
            <Input v-model="searchItem.assesseds" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('PB_Successors')"
            ><!-- 继任盘点对象 -->
            <Input v-model="searchItem.successors" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Attendees')"
            ><!-- 参加会议人员 -->
            <Input v-model="searchItem.meetings" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Authorised_Person')"
            ><!-- 授权人员 -->
            <Input v-model="searchItem.authorizes" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('PB_Meeting_Status')"
            ><!-- 会议状态 -->
            <Select v-model="searchItem.beEnd" clearable>
              <Option
                v-for="item in MeetingStatus"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>

        <Col :xs="12" :sm="12" :md="6" :lg="4">
          <Button @click="(total = 0), (pageInfo.pageNo = 1), getData()"
            ><!-- 检 索 -->{{ $t("Search") }}</Button
          >
          <Button @click="handleReset()"
            ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
          >
        </Col>
      </Row>
    </Form>
    <div class="butList">
      <Button
        type="primary"
        style="margin-right: 10px"
        icon="md-list"
        @click="cardShow = false"
      ></Button>
      <Button type="primary" icon="ios-apps" @click="cardShow = true"></Button>
    </div>
    <Table
      border
      :columns="columns"
      :data="columnsData"
      :loading="loading"
      v-show="!cardShow"
    >
      <template slot-scope="{ row }" slot="beEndName" style="width: 100%">
        <Tag :color="beEndNameColor(row.beEndName)">{{
          lang == "zh" ? row.beEndName : row.beEnEndName
        }}</Tag>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="meetingName"
        style="width: 100%"
      >
        <Input
          type="textarea"
          v-model="row.meetingName"
          :autosize="true"
          @on-change="targetItemChange(row, index, 'meetingName')"
        />
      </template>
      <template
        slot-scope="{ row, index }"
        slot="meetingDate"
        style="width: 100%"
      >
        <DatePicker
          type="date"
          v-model="row.meetingDate"
          :transfer="true"
          @on-change="targetItemChange(row, index, 'meetingDate')"
        ></DatePicker>
      </template>
      <template slot-scope="{ row, index }" slot="hostName" style="width: 100%">
        <Input v-model="row.hostName" disabled></Input>
      </template>
      <template slot-scope="{ row, index }" slot="meetingType">
        <Select
          v-model="row.meetingType"
          @on-change="targetItemChange(row, index, 'meetingType')"
          transfer
        >
          <Option
            v-for="item in row.year > '2025' ? newMeetingTypeList : meetingTypeList "
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="assessedList">
        <div style="display: flex; justify-content: center; margin: 10px 0">
          <Tag type="border">{{ row.assessedList.length }}</Tag>
          <Button
            style="margin-left: 6px"
            shape="circle"
            size="small"
            @click="onisSelectPeraon(row, index, 'assessedList')"
            icon="ios-search"
          ></Button>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="successorList">
        <div
          style="
            display: flex;
            justify-content: center;
            margin: 10px 0;
            align-items: center;
          "
        >
          <!-- <Tag type="border">{{row.successorList.length}} + {{row.nullJobList.length}}</Tag> -->
          <Tag type="border">{{ row.successorNum }}</Tag>
          <Button
            shape="circle"
            size="small"
            @click="onisSelectPeraon(row, index, 'successorList')"
            icon="ios-search"
          ></Button>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="meetingList">
        <div style="display: flex; justify-content: center; margin: 10px 0">
          <div style="display: flex; flex-wrap: wrap; width: 80%">
            <div
              v-for="(item, i) in row.meetingList"
              :key="i"
              style="display: flex; flex-wrap: wrap"
              v-if="i < 3"
            >
              <Tag type="border">{{ item.userName }}</Tag>
            </div>
            <Poptip
              placement="right"
              width="280"
              v-if="row.meetingList && row.meetingList.length > 3"
            >
              <Button icon="ios-more" size="small"></Button>
              <div class="Poptipapi" slot="content">
                <Tag v-for="(item, i1) in row.meetingList" :key="i1">{{
                  item.userName
                }}</Tag>
              </div>
            </Poptip>
          </div>
          <Button
            shape="circle"
            size="small"
            :disabled="row.beEnd == 1"
            @click="onSelectPeraon(row, index, 'meetingList')"
            icon="ios-search"
          ></Button>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="authorizeList">
        <div style="display: flex; justify-content: center; margin: 10px 0">
          <div style="display: flex; flex-wrap: wrap; width: 80%">
            <div
              v-for="(item, i) in row.authorizeList"
              :key="i"
              style="display: flex; flex-wrap: wrap"
              v-if="i < 3"
            >
              <Tag type="border">{{ item.userName }}</Tag>
            </div>
            <Poptip
              placement="right"
              width="280"
              v-if="row.authorizeList && row.authorizeList.length > 3"
            >
              <Button icon="ios-more" size="small"></Button>
              <div class="Poptipapi" slot="content">
                <Tag v-for="(item, i1) in row.authorizeList" :key="i1">{{
                  item.userName
                }}</Tag>
              </div>
            </Poptip>
          </div>
          <Button
            shape="circle"
            size="small"
            @click="onSelectPeraon(row, index, 'authorizeList')"
            icon="ios-search"
          ></Button>
        </div>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="sendMailFlag"
        style="width: 100%"
      >
        <!-- <Checkbox v-model="row.sendMailFlag" @on-change="targetItemChange(row, index, 'sendMailFlag')"></Checkbox> -->
        <Button type="primary" size="small" @click="sendMail(row, index)"
          ><!-- 保存 -->{{ $t("Send") }}</Button
        >
      </template>
      <template slot="action1" slot-scope="{ row, index }">
        <Button
          type="warning"
          size="small"
          style="margin-right: 8px"
          :disabled="row.beEnd == 1 || row.beEnd == 4"
          @click="saveItem(row, index)"
          ><!-- 保存 -->{{ $t("Save") }}</Button
        >
        <Button
          type="primary"
          size="small"
          style="margin-right: 8px"
          @click="paceTable(row, index)"
          :disabled="row.beEnd == '1' || row.beEnd == 4"
          ><!-- 激活PB Session -->{{ $t("Activate_PB_Session") }}</Button
        >
        <Button
          type="error"
          size="small"
          :disabled="row.beEnd == 1 || row.beEnd == 4"
          @click="deleteItem(row, index)"
          ><!-- 删除 -->{{ $t("Delete") }}</Button
        >
      </template>
      <template slot="action2" slot-scope="{ row, index }">
        <Button
          type="primary"
          size="small"
          :disabled="row.details"
          icon="md-menu"
          @click="pageReturn(row, index)"
        ></Button>
      </template>
    </Table>
    <div class="cardDiv" v-show="cardShow">
      <Card
        class="cardList"
        style="width: 305px"
        v-for="(row, index) in columnsData"
        :key="index"
      >
        <Form
          :label-width="98"
          label-position="left"
          style="margin-bottom: 30px"
        >
          <FormItem :label="$t('PB_Meeting_Status')"
            ><!-- 会议状态 -->
            <Tag :color="beEndNameColor(row.beEndName)">{{
              row.beEndName
            }}</Tag>
          </FormItem>
          <FormItem :label="$t('Meeting_Subjects')"
            ><!-- 会议名称 -->
            <Input
              type="textarea"
              v-model="row.meetingName"
              :autosize="true"
              @on-change="targetItemChange(row, index, 'meetingName')"
            />
          </FormItem>
          <FormItem :label="$t('Meeting_Date')"
            ><!-- 会议时间 -->
            <DatePicker
              type="date"
              v-model="row.meetingDate"
              :transfer="true"
              @on-change="targetItemChange(row, index, 'meetingDate')"
            ></DatePicker>
          </FormItem>

          <FormItem :label="$t('Meeting_Type')"
            ><!-- 会议类型 -->
            <Select
              v-model="row.meetingType"
              @on-change="targetItemChange(row, index, 'meetingType')"
              transfer
            >
              <Option
                v-for="item in row.year > '2025' ? newMeetingTypeList : meetingTypeList"
                :value="item.code"
                :key="item.code"
                >{{ item.ch_value }}</Option
              >
            </Select>
          </FormItem>
          <FormItem :label="$t('Appraisee')"
            ><!-- 被评估人员 -->
            <div
              style="
                display: flex;
                justify-content: flex-start;
                margin: 5px 0;
                align-items: center;
              "
            >
              <Tag type="border">{{ row.assessedList.length }}</Tag>
              <Button
                shape="circle"
                size="small"
                @click="onisSelectPeraon(row, index, 'assessedList')"
                icon="ios-search"
              ></Button>
            </div>
          </FormItem>
          <FormItem :label="$t('PB_Successors')"
            ><!-- 继任盘点对象 -->
            <div
              style="
                display: flex;
                justify-content: flex-start;
                margin: 5px 0;
                align-items: center;
              "
            >
              <Tag type="border">{{ row.successorNum }}</Tag>
              <Button
                shape="circle"
                size="small"
                @click="onisSelectPeraon(row, index, 'successorList')"
                icon="ios-search"
              ></Button>
            </div>
          </FormItem>
          <FormItem :label="$t('Attendees')"
            ><!-- 参加会议人员 -->
            <div style="display: flex; justify-content: center; margin: 5px 0">
              <div style="display: flex; flex-wrap: wrap; width: 80%">
                <div
                  v-for="(item, i) in row.meetingList"
                  :key="i"
                  style="display: flex; flex-wrap: wrap"
                  v-if="i < 2"
                >
                  <Tag type="border">{{ item.userName }}</Tag>
                </div>
                <Poptip
                  placement="right"
                  width="280"
                  v-if="row.meetingList && row.meetingList.length > 2"
                >
                  <Button
                    icon="ios-more"
                    size="small"
                    style="margin-top: -6px"
                  ></Button>
                  <div class="Poptipapi" slot="content">
                    <Tag v-for="(item, i1) in row.meetingList" :key="i1">{{
                      item.userName
                    }}</Tag>
                  </div>
                </Poptip>
              </div>
              <Button
                shape="circle"
                size="small"
                :disabled="row.beEnd == 1 || row.beEnd == 4"
                @click="onSelectPeraon(row, index, 'meetingList')"
                icon="ios-search"
              ></Button>
            </div>
          </FormItem>
          <FormItem :label="$t('Authorised_Person')"
            ><!-- 授权人员 -->
            <div style="display: flex; justify-content: center; margin: 5px 0">
              <div style="display: flex; flex-wrap: wrap; width: 80%">
                <div
                  v-for="(item, i) in row.authorizeList"
                  :key="i"
                  style="display: flex; flex-wrap: wrap"
                  v-if="i < 2"
                >
                  <Tag type="border">{{ item.userName }}</Tag>
                </div>
                <Poptip
                  placement="right"
                  width="280"
                  v-if="row.authorizeList && row.authorizeList.length > 2"
                >
                  <Button
                    icon="ios-more"
                    size="small"
                    style="margin-top: -6px"
                  ></Button>
                  <div class="Poptipapi" slot="content">
                    <Tag v-for="(item, i1) in row.authorizeList" :key="i1">{{
                      item.userName
                    }}</Tag>
                  </div>
                </Poptip>
              </div>
              <Button
                shape="circle"
                size="small"
                @click="onSelectPeraon(row, index, 'authorizeList')"
                icon="ios-search"
              ></Button>
            </div>
          </FormItem>
          <FormItem :label="$t('Send_mail')"
            ><!-- 是否发送邮件 -->
            <Button type="primary" size="small" @click="sendMail(row, index)"
              ><!-- 保存 -->{{ $t("Send") }}</Button
            >
            <!-- <Checkbox v-model="row.sendMailFlag" @on-change="targetItemChange(row, index, 'sendMailFlag')"></Checkbox> -->
          </FormItem>
          <FormItem :label="$t('PB_Meeting_Owner')"
            ><!-- 会议管理员 -->
            <Input v-model="row.hostName" disabled></Input>
          </FormItem>
          <div class="cardFooter">
            <Button
              type="warning"
              size="small"
              style="margin-right: 4px"
              @click="saveItem(row, index)"
              ><!-- 保存 -->{{ $t("Save") }}</Button
            >
            <Button
              type="primary"
              size="small"
              style="margin-right: 4px"
              @click="paceTable(row, index)"
              :disabled="row.beEnd == 1 || row.beEnd == 4"
              ><!-- 激活PB Session -->{{ $t("Activate_PB_Session") }}</Button
            >
            <Button
              type="error"
              size="small"
              style="margin-right: 4px"
              :disabled="row.beEnd == 1 || row.beEnd == 4"
              @click="deleteItem(row, index)"
              ><!-- 删除 -->{{ $t("Delete") }}</Button
            >
            <Button
              type="primary"
              size="small"
              :disabled="row.details"
              @click="pageReturn(row, index)"
              ><!-- 查看 -->{{ $t("Check") }}</Button
            >
          </div>
        </Form>
      </Card>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
    <div
      style="display: flex; justify-content: space-between; margin-top: 30px"
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        transfer
        :page-size="pageInfo.pageSize"
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <Button @click="addRow" style="margin-right: 15px"
        ><!-- 新增 -->{{ $t("Add") }}</Button
      >
    </div>
    <selectPeopleVue
      ref="peoModal"
      @onSelectList="onSelectList"
      @peoSave="peoSave"
    />
    <isselectPeopleVue
      ref="ispeoModal"
      @onSelectList="onSelectList"
    ></isselectPeopleVue>
    <!-- <PDJob ref="PDJob" @jobSelectList="jobSelectList"></PDJob> -->
    <Modal v-model="sessionModal" :title="$t('Selected_Appraisee')"
      ><!-- 已选择的被评估员工 -->
      <Table
        border
        size="small"
        :columns="modalColumns"
        :loading="sessionLoading"
        :data="sessionData"
        style="margin: 20px 0"
      ></Table>
      <div style="display: flex; justify-content: flex-end; width: 100%">
        <Page :total="total1" @on-change="pageChange1" />
      </div>

      <div slot="footer">
        <Button @click="sessionModal = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <Modal v-model="paceSessionModal" :title="$t('longText32')"
      ><!-- 未提交初评结果的人员名单，及直线经理 -->
      <Table
        border
        size="small"
        :columns="modalColumnsA"
        :data="sessionDataA"
        style="margin: 20px 0"
      ></Table>
      <div style="display: flex; justify-content: flex-end; width: 100%">
        <Page :total="total2" @on-change="pageChange2" />
      </div>

      <div slot="footer">
        <Button @click="paceSessionModal = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <Spin size="large" fix v-if="pbLoading">{{
      issynchronizationEvaResult
    }}</Spin>
  </div>
</template>
<script>
import isselectPeopleVue from "./PeopleBoardComponents/PDIsSelectPeople.vue";
import selectPeopleVue from "./PeopleBoardComponents/PDselectPeople.vue";
import axios from "axios";
import EventBus from "@/util/eventBus.js";
import PDJob from "./PeopleBoardComponents/PDJob";
import DateUtil from "@/util/DateUtil";
export default {
  components: { selectPeopleVue, isselectPeopleVue, PDJob },
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      modal: false,
      dateYear: new Date().getFullYear(),
      formItem: {},
      modalFormItem: {},
      editFormItem: {},
      meetingTypeList: [],
      newMeetingTypeList: [],
      searchItem: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      columnsData: [],
      targetkey: "",
      targetIndex: "",
      meetlist: [],
      MeetingStatus: "",
      sessionModal: false,
      sessionData: [],
      total1: 0,
      pageInfo1: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      item: {},
      sessionLoading: false,
      meetId: "",
      rowItem: {},
      cardShow: false,
      pageWidth: "",
      modalColumnsA: [
        {
          title: this.$t("userName"), //员工姓名
          key: "userName",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("Line_Manager"), //直线经理
          key: "dirSupName",
          align: "center",
          minWidth: 160,
        },
      ],
      sessionDataA: [],
      total2: 0,
      pageInfo2: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      paceId: "",
      paceYear: "",
      paceSessionModal: false,
      issynchronizationEvaResult: "",
      pbLoading: false,
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("PB_Meeting_Status") /* 会议状态 */,
          slot: "beEndName",
          align: "center",
          minWidth: 150,
        },
        {
          title: this.$t("Meeting_Subjects") /* 会议名称 */,
          slot: "meetingName",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Meeting_Date") /* 会议时间 */,
          slot: "meetingDate",
          align: "center",
          minWidth: 150,
        },
        {
          title: this.$t("Meeting_Type") /* 会议类型 */,
          slot: "meetingType",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Appraisee") /* 被评估人员 */,
          slot: "assessedList",
          align: "center",
          minWidth: 110,
        },
        {
          title: this.$t("PB_Successors") /* 继任盘点对象 */,
          slot: "successorList",
          align: "center",
          minWidth: 130,
        },
        {
          title: this.$t("Attendees") /* 参加会议人员 */,
          slot: "meetingList",
          align: "center",
          minWidth: 300,
        },
        {
          title: this.$t("Authorised_Person") /* 授权人员 */,
          slot: "authorizeList",
          align: "center",
          minWidth: 300,
        },
        {
          title: this.$t("PB_Meeting_Owner") /* 会议管理员 */,
          slot: "hostName",
          align: "center",
          minWidth: 110,
        },
        {
          title: this.$t("Send_mail") /* 是否发送邮件 */,
          slot: "sendMailFlag",
          align: "center",
          minWidth: 90,
          fixed: "right",
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action1",
          align: "center",
          minWidth: 310,
          fixed: "right",
        },
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action2",
          align: "center",
          minWidth: 80,
          fixed: "right",
        },
      ];
    },
    modalColumns() {
      return [
        {
          title: this.$t("employee_type") /* 员工类型 */,
          key: "peopleType",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("Name"),
          key: "userName",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("PB_Meeting_Owner") /* 会议管理员 */,
          key: "talentUserName",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Meeting_Subjects") /* 会议名称 */,
          key: "meetingName",
          align: "center",
          minWidth: 160,
        },
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  created() {
    this.getListData();
    this.getData();
  },

  mounted() {
    this.pageWidth = document.documentElement.clientWidth;
    window.onresize = () => {
      return (() => {
        this.pageWidth = document.documentElement.clientWidth;
        if (this.pageWidth > 1140) {
          this.cardShow = false;
        } else {
          this.cardShow = true;
        }
      })();
    };
    EventBus.$on("savePerson", async () => {
      await this.getData();
      this.$refs.ispeoModal.id = this.columnsData[this.targetIndex].id;
      this.$refs.ispeoModal.getData(this.columnsData[this.targetIndex].id);
      this.$refs.ispeoModal.$refs.peoModal.rowItem =
        this.columnsData[this.targetIndex];
    });
    this.$store.state.tabValue = "";
  },
  methods: {
    getData() {
      this.loading = true;
      return axios
        .post("/TalentInventory/selectTalentInventory", {
          ...this.pageInfo,
          ...this.searchItem,
        })
        .then((res) => {
          this.loading = false;
          if (res) {
            this.columnsData = res.data;
            this.total = parseInt(res.pageInfo.total);
            this.columnsData.forEach((el, index) => {
              el.successorNum = el.successorList.length + el.nullJobList.length;
              el.sendMailFlag = !!+el.sendMailFlag;
              if (el.meetingType == "" || !el.meetingType) {
                el.details = true;
              } else {
                el.details = false;
              }
            });
          }
        });
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.meetingTypeList = res.MeetingType;
          this.newMeetingTypeList = res.newMeetingType;
          this.$refs.peoModal.positionList = res.positionList;
          this.$refs.peoModal.ApplyStatus = res.ApplyStatus;
          this.$refs.peoModal.departmentList = res.departmentList;
          this.$refs.peoModal.businessUnitList = res.businessUnitList;
          this.$refs.peoModal.Level = res.Level;
          this.$refs.peoModal.Band = res.Band;
          this.MeetingStatus = res.MeetingStatus;
        }
      });
    },
    onSelectPeraon(row, index, key) {
      if (row.meetingName == "" || !row.meetingName) {
        this.$Message.error(this.$t("The_meeting_subjects_can_not_be_empty"));
        return;
      } /* 会议名称不能为空 */ else if (
        row.meetingDate == "" ||
        !row.meetingDate
      ) {
        this.$Message.error(this.$t("The_meeting_date_can_not_be_empty"));
        return;
      } /* 会议时间不能为空 */ else if (
        row.meetingType == "" ||
        !row.meetingType
      ) {
        this.$Message.error(this.$t("Please_select_meeting_type"));
        return;
      } /* 请选择会议类型 */
      this.targetkey = key;
      this.targetIndex = index;
      let obj = JSON.parse(JSON.stringify(row));
      let json = JSON.parse(JSON.stringify(row));
      json.sendMailFlag ? (json.sendMailFlag = "1") : (json.sendMailFlag = "0");
      axios
        .post("/TalentInventory/saveTalentInventory", json)
        .then((res) => {});
      this.rowItem = JSON.parse(JSON.stringify(row));
      this.meetId = row.id;
      let userType = 3;
      let btnShow = false;
      key == "authorizeList" ? (userType = 3) : (userType = 2);
      this.$router.push({
        path: "/0C09243B747B4CFE8919A799C2A754DA3C83A09DFEF5A3FD1FC6BD2C843BAABC/A3FFBEBFDB713E27",
        query: {
          id: obj.id,
          userType: userType,
          btnShow: btnShow,
          targetkey: key,
        },
      });
      // this.$refs.peoModal.selectList=obj[`${key}`]
      // this.$refs.peoModal.modal = true;
      // this.$refs.peoModal.id = row.id;
      // this.$refs.peoModal.targetkey = key
      // this.$refs.peoModal.rowItem=obj
      // key=='authorizeList'?this.$refs.peoModal.userType=3:this.$refs.peoModal.userType=2
      // this.$refs.peoModal.getIsData()
    },
    onisSelectPeraon(row, index, key) {
      if (row.meetingName == "" || !row.meetingName) {
        this.$Message.error(this.$t("The_meeting_subjects_can_not_be_empty"));
        return;
      } /* 会议名称不能为空 */ else if (
        row.meetingDate == "" ||
        !row.meetingDate
      ) {
        this.$Message.error(this.$t("The_meeting_date_can_not_be_empty"));
        return;
      } /* 会议时间不能为空 */ else if (
        row.meetingType == "" ||
        !row.meetingType
      ) {
        this.$Message.error(this.$t("Please_select_meeting_type"));
        return;
      } /* 请选择会议类型 */
      this.targetkey = key;
      this.targetIndex = index;
      let obj = JSON.parse(JSON.stringify(row));
      let json = JSON.parse(JSON.stringify(row));
      json.sendMailFlag ? (json.sendMailFlag = "1") : (json.sendMailFlag = "0");
      axios
        .post("/TalentInventory/saveTalentInventory", json)
        .then((res) => {});
      this.rowItem = JSON.parse(JSON.stringify(row));
      this.meetId = row.id;
      let userType = 1;
      let btnShow = false;
      key == "assessedList" ? (userType = 1) : (userType = 4);
      key == "assessedList" ? (btnShow = false) : (btnShow = true);

      this.$router.push({
        path: "/0C09243B747B4CFE8919A799C2A754DA3C83A09DFEF5A3FD1FC6BD2C843BAABC/A3FFBEBFDB713E27",
        query: {
          id: obj.id,
          userType: userType,
          btnShow: btnShow,
          targetkey: key,
        },
      });
      // obj[`${key}`]?this.$refs.peoModal.selectList=obj[`${key}`]:''
      // this.$refs.peoModal.modal = true;
      // this.$refs.peoModal.id = row.id;
      // this.$refs.peoModal.targetkey = key
      // this.$refs.peoModal.rowItem=obj
      // key=='assessedList'?this.$refs.peoModal.userType=1:this.$refs.peoModal.userType=4
      // key=='assessedList'?this.$refs.peoModal.btnShow=false:this.$refs.peoModal.btnShow=true
      // this.$refs.peoModal.beEnd=row.beEnd
      // this.$refs.peoModal.getIsData()
      // this.targetkey=key
      // this.targetIndex=index
      // let obj=JSON.parse(JSON.stringify(row))
      // this.$refs.ispeoModal.selectList=obj[`${key}`]
      // this.$refs.ispeoModal.pdmodal = true;
      // this.$refs.ispeoModal.id=row.id
      // this.$refs.peoModal.beEnd=row.beEnd
      // key=='assessedList'?this.$refs.ispeoModal.userType=1:this.$refs.ispeoModal.userType=4
      // key=='assessedList'?this.$refs.ispeoModal.btnShow=false:this.$refs.ispeoModal.btnShow=true
      // this.$refs.ispeoModal.targetIndex=index
      // this.$refs.ispeoModal.$refs.peoModal.rowItem=obj
      // this.$refs.ispeoModal.$refs.peoModal.targetkey=key
      // this.$refs.ispeoModal.getData(row.id)
    },
    onJobModal(row, index, key) {
      this.targetkey = key;
      this.targetIndex = index;
      let obj = JSON.parse(JSON.stringify(row));
      this.$refs.PDJob.modal = true;
      this.$refs.PDJob.id = row.id;
      this.$refs.PDJob.beEnd = row.beEnd;
      this.$refs.PDJob.getData();
      obj[`successorList`]
        ? (this.$refs.PDJob.jobselectList = [...obj[`successorList`]])
        : "";
      // obj[`${key}`]?this.$refs.PDJob.modelData=[...obj[`${key}`]]:''
    },
    // onselect(row){
    //   this.$set(this.columnsData[this.targetIndex], 'hostName', row.userName);
    //   this.$set(this.columnsData[this.targetIndex], 'hostId', row.empCode);
    // },
    targetItemChange(row, index, key) {
      this.targetIndex = index;
      key && this.$set(this.columnsData[index], key, row[`${key}`]);
    },
    sendMail(row, index) {
      this.$Modal.confirm({
        title: this.$t("Emp_Ach_mess16"),
        onOk: () => {
          this.loading = true;
          axios
            .post("/TalentInventory/sendMeetingEmail", { id: row.id })
            .then((res) => {
              this.loading = false;
              if (res) {
                this.$Message.success(this.$t("Emp_Ach_mess17")); //发送成功
              }
            });
        },
      });
    },
    onSaveRow(index) {
      this.editFormItem = this.columnsData.filter((item, i) => {
        return index == i;
      })[0];
    },
    onDeleteRow(index) {
      this.columnsData.splice(index, 1);
    },
    addRow() {
      axios.post("/TalentInventory/createTalentInventory", {}).then((res) => {
        if (res) {
          this.columnsData.push({
            meetingName: "",
            meetingDate: "",
            hostId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
            hostName: JSON.parse(sessionStorage.getItem("userInfo")).userName,
            meetingType: "",
            assessedList: [],
            meetingList: [],
            authorizeList: [],
            successorList: [],
            id: res.id,
            sendMailFlag: "",
            beEndName: res.beEndName,
            details: true,
            year: res.year
          });
        }
      });
    },
    onSelectList(list) {
      this.getData();
      // if(this.targetkey=='assessedList'){
      //   this.$set(this.columnsData[this.targetIndex], 'successorList', list);
      // }
      // this.$set(this.columnsData[this.targetIndex], this.targetkey, list);
    },
    jobSelectList(list) {
      this.$set(this.columnsData[this.targetIndex], this.targetkey, list);
    },
    peoSave(item) {
      // if(this.targetkey=='assessedList'){
      //   this.rowItem['successorList']=list
      // }
      //  this.rowItem[this.targetkey]=list
      this.sessionModal = true;
      this.getSessionData(item);
    },
    saveItem(row, index) {
      if (row.meetingName == "") {
        this.$Message.error(this.$t("The_meeting_subjects_can_not_be_empty"));
        return;
      } /* 会议名称不能为空 */ else if (row.meetingDate == "") {
        this.$Message.error(this.$t("The_meeting_date_can_not_be_empty"));
        return;
      } /* 会议时间不能为空 */ else if (row.meetingType == "") {
        this.$Message.error(this.$t("Please_select_meeting_type"));
        return;
      } /* 请选择会议类型 */
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_save"),
        onOk: () => {
          let obj = JSON.parse(JSON.stringify(row));
          // obj.sendMailFlag?obj.sendMailFlag='1':obj.sendMailFlag='0'
          this.loading = true;
          axios
            .post("/TalentInventory/saveTalentInventory", obj)
            .then((res) => {
              this.loading = false;
              if (res != null && res.length > 0) {
                this.sessionModal = true;
                this.getSessionData(row);
              } else {
                this.$Message.success(this.$t("Save_Successful"));
                this.getData();
              }
            });
        },
      });
    },
    deleteItem(row, index) {
      if (row.id) {
        this.$Modal.confirm({
          title: this.$t("Are_you_sure_to_delete"),
          onOk: () => {
            axios
              .post("/TalentInventory/deleteTalentInventory", { id: row.id })
              .then((res) => {
                if (res) {
                  this.$Message.success(res);
                  this.getData();
                }
              });
          },
        });
      } else {
        this.columnsData.splice(index, 1);
      }
    },
    getSessionData(row) {
      this.item = JSON.parse(JSON.stringify(row));
      let obj = JSON.parse(JSON.stringify(row));
      // obj.sendMailFlag?obj.sendMailFlag='1':obj.sendMailFlag='0'
      this.sessionLoading = true;
      axios
        .post("/TalentInventory/checkTalentAssess", {
          ...obj,
          ...this.pageInfo1,
        })
        .then((res) => {
          this.sessionLoading = false;
          if (res) {
            this.sessionData = res.data;
            this.total1 = parseInt(res.pageInfo.total);
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    pageChange1(val) {
      this.pageInfo1.pageNo = val;
      this.getSessionData(this.item);
    },
    pageReturn(row, index) {
      let plan =
        row.meetingType == "People Board"
          ? "1"
          : row.meetingType == "绩效校准会"
          ? "3"
          : "2";
      if (row.meetingType == "Talent Forum") {
        plan = "4";
      }
      this.$router.push({
        path: "/86DF9F71935052AFE31847CDA1679EF4BA610C6A6F738319/A3FFBEBFDB713E27",
        query: {
          plan: plan,
          id: row.id,
          beEnd: row.beEnd,
          meetingName: row.meetingName,
          year: row.year,
        },
      });
    },
    beEndNameColor(val) {
      if (val == "未激活") return "cyan";
      else if (val == "待校准") return "green";
      else if (val == "校准中") return "orange";
      else if (val == "已结束") return "red";
      else if (val == "已审批") return "blue";
    },
    paceTable(row, index) {
      // this.issynchronizationEvaResult = "绩效趋势计算中，请等待";
      this.pbLoading = true;
      this.paceId = row.id;
      this.paceYear = row.meetingDate;
      axios
        .post("/AchPeopleBoard/synchronizationEvaResult", {
          id: row.id,
          year: this.date.dateVal(row.meetingDate, "YYYY"),
        })
        .then((res) => {
          this.pbLoading = false;
          if (res != null && res.length > 0) {
            this.paceSessionModal = true;
            if (row.meetingType != "人才盘点会") {
              this.getPaceSessionData();
            }
          } else {
            if (res != null && res.length == 0) {
              this.$Message.success(this.$t("Emp_Ach_mess18")); //激活成功
              this.issynchronizationEvaResult = "";
            }
            this.getData(JSON.stringify(this.searchItem));
          }
        });
    },
    getPaceSessionData() {
      axios
        .post("/AchPeopleBoard/selectBeSubmitStartInfo", {
          ...this.pageInfo2,
          id: this.paceId,
          year: this.paceYear,
        })
        .then((res) => {
          if (res) {
            this.sessionDataA = res.data;
            this.total2 = parseInt(res.pageInfo.total);
          }
        });
    },
    pageChange2(val) {
      this.pageInfo2.pageNo = val;
      this.getPaceSessionData();
    },
    handleReset() {
      this.searchItem = {};
      // this.pageInfo.pageNo=1
      // this.getData()
    },
  },
};
</script>

<style lang="less" scoped>
.Poptipapi {
  display: flex;
  flex-wrap: wrap;
}
.cardDiv {
  display: flex;
  flex-wrap: wrap;
  widows: 100%;
  .cardList {
    margin: 8px;
    position: relative;
    .cardFooter {
      position: absolute;
      bottom: 5px;
      right: 10px;
    }
  }
  /deep/.ivu-form-item {
    margin-bottom: 6px !important;
  }
}
.successorDiv {
  padding: 5px 1px;
  background: #ececec;
}

/deep/.ivu-card-bordered {
  border: 3px solid #dcdee2;
}
.butList {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PopleBoard.vue